import { snackbarController } from 'reactApp/modules/snackbar/snackbar.controller';
import { SnackbarTypes } from 'reactApp/modules/snackbar/snackbar.types';
import { copy as copyToClipboard } from 'reactApp/utils/copyToClipboard';
import { sendXray } from 'reactApp/utils/ga';

export const copyEmailAddress = async (email: string) => {
    try {
        const { hasBeenCopied } = await copyToClipboard(email);

        if (hasBeenCopied) {
            snackbarController.showSnackbar({
                type: SnackbarTypes.success,
                text: 'Адрес успешно скопирован',
                id: 'copyLink',
                closable: true,
            });
            sendXray('copy-email_context-menu_shared-docs_success');
        }
        sendXray('copy-email_context-menu_shared-docs_error');
    } catch {
        snackbarController.showSnackbar({
            type: SnackbarTypes.failure,
            text: 'Не удалось скопировать адрес',
            id: 'copyLink',
            closable: true,
        });
        sendXray('copy-email_context-menu_shared-docs_error');
    }
};
